<template>
    <div class="block-region-bottm-bnr">
        <div class="block block-ctools block-entity-viewnode">
            <div id="footer-banner-links">
                <ul class="bottm_bnr clearfix">
                    <li>
                        <a
                            href="https://www.agropedia.affrc.go.jp/"
                            target="_blank"
                        >
                            <img src="/images/bnr/bnr_01.jpg" alt="AGROPEDIA" />
                        </a>
                    </li>
                    <li>
                        <a href="https://opac.cc.affrc.go.jp/" target="_blank">
                            <img
                                src="/images/bnr/bnr_02.jpg"
                                alt="WebOPAC 簡易検索"
                            />
                        </a>
                    </li>
                    <li>
                        <a
                            href="https://itcweb.cc.affrc.go.jp/"
                            target="_blank"
                        >
                            <img
                                src="/images/bnr/bnr_03.jpg"
                                alt="農林水産研究情報総合センター [AFFRIT Portal]"
                            />
                        </a>
                    </li>
                    <li>
                        <a
                            href="https://www.affrc.maff.go.jp/tsukuba/top/"
                            target="_blank"
                        >
                            <img
                                src="/images/bnr/bnr_04.jpg"
                                alt="農林水産技術会議事務局 筑波産学連携支援センター"
                            />
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="j_stage_credit">
            AgriKnowledge
            サイトで提供するデータのうち論文情報については、国立研究開発法人科学技術振興機構(JST)の「<a
                href="https://www.jstage.jst.go.jp/browse/-char/ja"
                >J-STAGE</a
            >」のデータの一部を使用させていただいています。
        </div>
    </div>
</template>

<script>
export default {
    name: "Banner",
};
</script>

<style scoped>
.bottm_bnr {
    margin-top: 50px;
    margin-right: -40px;
    overflow: hidden;
}
.bottm_bnr li {
    float: left;
    margin: 0 20px 20px 0;
}
.j_stage_credit {
    flex: auto;
    margin-bottom: 2rem;
    font-size: 92.85%;
}
</style>
